import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { StateStatuses } from '@app/store/enums/state-statuses.enum';
import { AuthDataForm } from '@app/store/models/auth-data.interface';
import { Store } from '@ngrx/store';
import { selectAuthState } from '../../store/selectors/auth.selectors';
import { Subscription } from 'rxjs';
import { SessionInfo } from '@app/store/models/session-info.interface';
import { CoreService } from '@app/modules/core/services/core.service';

@Component({
  selector: 'app-auth-otp',
  templateUrl: './auth-otp.component.html',
  styleUrls: ['./auth-otp.component.scss']
})
export class AuthOtpComponent implements OnInit {

  @Input() data: FormGroup<AuthDataForm>
  @Output() submit_clicked = new EventEmitter<boolean>()

  session_info: SessionInfo
  private subscriptions: Subscription[] = []

  state_statuses = {
    FAILED: StateStatuses.FAILED,
    PENDING: StateStatuses.PENDING,
    SUCCESS: StateStatuses.SUCCESS,
    PROCESSING: StateStatuses.PROCESSING,
  }
  authState$ = this.store.select(selectAuthState);

  constructor(
    private store: Store,
    private coreService: CoreService
  ) {
    this.subscriptions.push(this.coreService.session_dataObservable.subscribe(si => this.session_info = si))
  }

  ngOnInit(): void {
  }

  jumpToNext(index: number) {
    if (index >= this.data.controls.otp.value.length) return
    if (!this.data.controls.otp.controls[index].value) return // Still fill current column
    document.getElementById(`otp_${index + 1}`)?.focus()
    if (!this.data.controls.otp.value.find(o => !o)) this.submit_clicked.emit(true)
  }

}
